import React, { useState, useEffect } from 'react';
import { Save, TrendingDown, TrendingUp, User, Wallet } from 'lucide-react';
import Swal from 'sweetalert2';

const SetPortfolio: React.FC = () => {
  const [customers, setCustomers] = useState<any[]>([]);
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [formData, setFormData] = useState({ type: 'PROFIT', amount: '' });
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    fetch('https://motilalalgo.com/api/admin/customers')
      .then(res => res.json())
      .then(data => {
        if (data.success) setCustomers(data.users.filter((u: any) => u.login_id)); // Only active
      });
  }, []);

  const handleUserSelect = (e: any) => {
    const user = customers.find(c => c.id === parseInt(e.target.value));
    setSelectedUser(user || null);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedUser || !formData.amount) return Swal.fire('Error', 'Fill all fields', 'error');

    setIsSaving(true);
    try {
      const res = await fetch('https://motilalalgo.com/api/admin/update-portfolio', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: selectedUser.id, ...formData })
      });
      const data = await res.json();
      if (data.success) {
        Swal.fire('Updated!', data.message, 'success');
        // Update local state temporarily so admin sees new balance immediately
        setSelectedUser({...selectedUser, wallet_balance: data.newBalance}); 
        setFormData({ ...formData, amount: '' });
      } else Swal.fire('Error', data.error, 'error');
    } catch (error) {
      Swal.fire('Error', 'Server connection failed', 'error');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto space-y-6">
      <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100">
        <h1 className="text-2xl font-black text-slate-800">Set User Portfolio</h1>
        <p className="text-sm text-slate-500 mt-1">Add Profit or Loss to a user's wallet directly.</p>
      </div>

      <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-xs font-bold text-slate-500 uppercase tracking-widest mb-2 flex items-center gap-2"><User size={14}/> Select Customer</label>
            <select onChange={handleUserSelect} className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl font-bold text-slate-800 outline-none">
              <option value="">-- Choose a Customer --</option>
              {customers.map(c => <option key={c.id} value={c.id}>{c.first_name} {c.last_name} (ID: {c.login_id})</option>)}
            </select>
          </div>

          {selectedUser && (
            <div className="bg-[#2d2780] p-4 rounded-xl text-white flex justify-between items-center shadow-lg">
              <div>
                <p className="text-xs text-indigo-200 uppercase font-bold tracking-wider">Current Wallet Balance</p>
                <p className="text-3xl font-black mt-1">₹{parseFloat(selectedUser.wallet_balance || 0).toFixed(2)}</p>
              </div>
              <Wallet size={36} className="text-white/20" />
            </div>
          )}

          <div className="grid grid-cols-2 gap-4">
            <button type="button" onClick={() => setFormData({...formData, type: 'PROFIT'})} className={`p-4 rounded-xl border-2 flex flex-col items-center gap-2 transition-all ${formData.type === 'PROFIT' ? 'border-green-500 bg-green-50 text-green-700 font-bold shadow-md' : 'border-slate-200 text-slate-500 hover:bg-slate-50'}`}>
              <TrendingUp size={28} /> Profit
            </button>
            <button type="button" onClick={() => setFormData({...formData, type: 'LOSS'})} className={`p-4 rounded-xl border-2 flex flex-col items-center gap-2 transition-all ${formData.type === 'LOSS' ? 'border-red-500 bg-red-50 text-red-700 font-bold shadow-md' : 'border-slate-200 text-slate-500 hover:bg-slate-50'}`}>
              <TrendingDown size={28} /> Loss
            </button>
          </div>

          <div>
            <label className="block text-xs font-bold text-slate-500 uppercase tracking-widest mb-2">Amount (₹)</label>
            <input type="number" required value={formData.amount} onChange={e => setFormData({...formData, amount: e.target.value})} className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl font-black text-xl outline-none focus:border-[#3b36a4]" placeholder="e.g. 15000" />
          </div>

          <button type="submit" disabled={isSaving} className="w-full bg-[#3b36a4] hover:bg-[#2d2780] text-white font-black py-4 rounded-xl shadow-lg transition-all flex justify-center gap-2">
            <Save size={20} /> {isSaving ? 'Updating...' : 'Apply & Save History'}
          </button>
        </form>
      </div>
    </div>
  );
};
export default SetPortfolio;